"use client";
import { CommonCMS } from "@lib/constants/contentful";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { Text } from "@ecco/ui/text";
import { Grid, GridItem } from "@ecco/ui/grid";
import type { FC, ReactNode } from "react";

interface Props {
    titleKey: string;
    children: ReactNode;
}

const AuthView: FC<Props> = ({ titleKey, children }) => {
    const { get: getMicrocopy } = useMicrocopy();
    const title = getMicrocopy(CommonCMS.shared, CommonCMS[titleKey]);

    return (
        <Grid
            gridTemplateColumns={["100%", "100%", "100%", "10fr 8fr"]}
            bg="white"
            mt={[2, 2, 2, 0]}
            py={6}
            px={[3, 4, 4, 6]}
        >
            <GridItem>
                <Text
                    fontSize={["mobileHeading3", "desktopHeading5"]}
                    fontWeight={"semibold"}
                    mb={6}
                    textTransform="uppercase"
                >
                    {title}
                </Text>
                {children}
            </GridItem>
        </Grid>
    );
};

export default AuthView;
